import { render } from "./dialogConfirmByPass.vue?vue&type=template&id=05cf5a94&scoped=true"
import script from "./dialogConfirmByPass.vue?vue&type=script&lang=js"
export * from "./dialogConfirmByPass.vue?vue&type=script&lang=js"

import "./dialogConfirmByPass.vue?vue&type=style&index=0&id=05cf5a94&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cf5a94"]])

export default __exports__